import { Grid, Stack } from "@mui/material";
import CustomProgressBar from "components/CustomProgressBar";
import CustomText from "components/typography/CustomText";
import { DEFAULT_BOXES } from "lib/global";
import { serverGet } from "lib/serverRequest";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";

export default function BoxesSummaryProgress({
  progress = {},
  data = [],
  progressType = "",
}) {
  const [maxBoxes, setMaxBoxes] = useState(0);

  useEffect(() => {
    serverGet({
      url: "box/capacity/get",
      onFinish: (res, err) => {
        if (res === false) {
          setMaxBoxes(DEFAULT_BOXES);
          return;
        }
        setMaxBoxes(res?.box_count ?? 200);
      },
    });
    //eslint-disable-next-line
  }, []);

  return (
    <Stack className="ml-5 h-full" justifyContent="space-between">
      {/* header */}
      <Grid container justifyContent="space-between">
        <Grid item>
          <CustomText variant="body2" bold={600} color="secondary">
            Week Slot Availability
          </CustomText>
        </Grid>
        {/* <Grid item>
          <Grid container wrap="nowrap">
            <Grid item className="pr-2 mr-2 border-r border-white-gray">
              <CustomText variant="body2" bold={600} color="secondary">
                {progress?.week ?? "Week 41"}
              </CustomText>
            </Grid>
            <Grid item className="pr-2 mr-2 border-r border-white-gray">
              <CustomText variant="body2" bold={600} color="secondary">
                {progress?.date ?? "09th September, 2021"}
              </CustomText>
            </Grid>
            <Grid item className="pr-2 mr-2 border-r border-white-gray">
              <CustomText variant="body2" bold={600} color="secondary">
                10:31 AM
              </CustomText>
            </Grid>
          </Grid>
        </Grid> */}
      </Grid>
      {/* progress bar */}
      <CustomProgressBar
        value={Number(data?.length / maxBoxes) * 100}
        progressType={progressType}
        label={
          Boolean(progressType)
            ? `${data?.length} | ${maxBoxes - data?.length}`
            : progress?.label ?? ""
        }
      />

      {/* footer */}
      <Grid container justifyContent="space-between">
        <Grid item>
          <CustomText bold={600} color="secondary">
            0 Boxes
          </CustomText>
        </Grid>
        <Grid item>
          <CustomText bold={600} color="secondary">
            {maxBoxes}&nbsp;Boxes
          </CustomText>
        </Grid>
      </Grid>
    </Stack>
  );
}
